import { type PageRouteData } from '@/features/shared/utils/setPageProps'
import { datadogRum } from '@datadog/browser-rum'

export function setGlobalContextFromRoute(routeData: PageRouteData) {
  const routeName = routeData?.routeName ?? 'UNKNOWN'
  datadogRum.setViewName(routeName)
}
